<template>
  <div class="scrollable only-y">
    <div class="page-header">
      <h1><i :class="'mdi mdi-' + $route.meta.icon"></i> {{ $route.name }}</h1>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="mdi mdi-home-outline"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.name }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="card-base card-shadow--medium p-30">
      <el-row :gutter="50">
        <el-col :span="24">
          <list-component/>
        </el-col>
      </el-row>

      <modal-third
      :modalOpen="modalOpen"
      @close="
        modalOpen = false;
      "
    ></modal-third>
    </div>
  </div>
</template>

<script>
import ModalThird from '@/views/pages/thirds/ModalThirds.vue'
import ListComponent from '@/views/pages/thirds/List.vue'
import FormComponent from '@/views/pages/thirds/Form.vue'
import { getAll, store, update, deletePerson } from "@/api/person";
export default {
  name: "Third",
  components: {
    ModalThird, ListComponent, FormComponent
  },
  data() {
    return {
      loading: false,
      loadingTable: false,
      loadingFilter: false,
      modalOpen: false,
      edit: false,
      tableData: [],
      docuemnt: "",
      // form: {
      //   documento: "",
      //   nombre: "",
      //   direccion: "",
      //   ciudad: "",
      //   email: "",
      //   telefono: "",
      //   nacimiento: "",
      //   cliente: null,
      //   vendedor: null,
      //   proveedor: null,
      // },
      //
      pageSize: 10,
      currentPage: 1,
      total_rows: 0,
    };
  },
  methods: {
    handleCurrentPage(val) {
      this.getAll(val);
    },
    filterTable() {
      this.loadingFilter = true;
      this.getAll();
    },
    getAll(current) {
      this.loadingTable = true;
      if (typeof current == "undefined") {
        if (this.document != null) {
          this.currentPage = 1;
        }
      } else {
        this.currentPage = current;
      }
      getAll(this.pageSize, this.currentPage, this.docuemnt)
        .then(({ data }) => {
          this.tableData = data.data;
          this.total_rows = data.total;
          this.loadingTable = false;
          this.loadingFilter = false;
        })
        .catch(function (error) {
          this.loadingTable = false;
          this.loadingFilter = false;
          console.log(error);
        });
    },
    // submitForm(formName) {
    //   this.loadingTable = true;
    //   this.$refs[formName].validate((valid) => {
    //     if (valid) {
    //       if (this.edit) {
    //         this.updateForm();
    //       } else {
    //         this.saveForm();
    //       }
    //     } else {
    //       this.loadingTable = false;
    //       console.log("error submit!!");
    //       return false;
    //     }
    //   });
    // },
    // saveForm() {
    //   store(this.form)
    //     .then(({ data }) => {
    //       this.loadingTable = false;
    //       if (data.code === 200) {
    //         this.getAll();
    //         this.resetForm("form");
    //       } else {
    //         this.$message.error("Error! " + data.error.errorInfo[2]);
    //       }
    //     })
    //     .catch(function (error) {
    //       this.loadingTable = false;
    //       console.log("Err: ", error);
    //     });
    // },
    // updateForm() {
    //   update(this.form)
    //     .then(({ data }) => {
    //       if (data.code === 200) {
    //         this.getAll();
    //         this.resetForm("form");
    //         this.loadingTable = false;
    //       } else {
    //         this.$message.error("Error! " + data.error.errorInfo[2]);
    //       }
    //     })
    //     .catch(function (error) {
    //       this.loadingTable = false;
    //       console.log("Err: ", error);
    //     });
    // },
    // resetForm(formName) {
    //   this.$refs[formName].resetFields();
    //   this.form.id = "";
    //   this.form.cliente = null;
    //   this.form.vendedor = null;
    //   this.form.proveedor = null;
    //   this.edit = false;
    //   this.loading = false;
    //   this.loadingTable = false;
    // },
    handleEdit(index, row) {
      this.edit = true;
      this.form.id = row.id;
      this.form.documento = row.documento;
      this.form.nombre = row.nombre;
      this.form.direccion = row.direccion;
      this.form.ciudad = row.ciudad;
      this.form.email = row.email;
      this.form.telefono = row.telefono;
      this.form.nacimiento = row.nacimiento;
      if (row.cliente == 1) {
        this.form.cliente = true;
      } else {
        this.form.cliente = false;
      }
      if (row.vendedor == 1) {
        this.form.vendedor = true;
      } else {
        this.form.vendedor = false;
      }
      if (row.proveedor == 1) {
        this.form.proveedor = true;
      } else {
        this.form.proveedor = false;
      }
    },
    handleDelete(index, row) {
      this.loadingTable = true;
      deletePerson({id:row.id})
        .then(({ data }) => {
          if (data.code === 200) {
            this.getAll();
            this.resetForm("form");
          } else {
            this.loadingTable = false;
            this.$message.error("Error! " + data.error.errorInfo[2]);
          }
        })
        .catch(function (error) {
          this.loadingTable = false;
          console.log("Err: ", error);
        });
    },
  },
  created() {
    this.getAll();
  },
};
</script>
<style lang="scss" scope>
.form {
  margin-top: 15px;
}
</style>
